import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../shared/shared.module';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import { OwlDateTimeModule, OWL_DATE_TIME_FORMATS } from 'ng-pick-datetime';
import {OwlMomentDateTimeModule} from 'ng-pick-datetime-moment';
import {UserSourceComponent} from './components/user-source/user-source.component';
import {UserService} from './services/user.service';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {NguiAutoCompleteModule} from '@ngui/auto-complete';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        BsDatepickerModule.forRoot(),
        OwlDateTimeModule,
        OwlMomentDateTimeModule,
        NgxDatatableModule,
        NguiAutoCompleteModule
    ],
    providers: [
        UserService,
    ],
    declarations: [UserSourceComponent]
})
export class UserModule {
}



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/user/user.module.ts